import type { MotionAmplificationJobId } from "../clients/motion-amplification";

const FINGERPRINT_SAMPLE_BYTES = 64 * 1024;

export type MultipartUploadSession = {
  jobId: MotionAmplificationJobId;
  sessionId: string;
  partSize: number;
  fileSize: number;
  fingerprint: string;
};

/** SHA-256 of file metadata and samples, not a full content checksum. */
export async function fingerprintFile(file: File): Promise<string> {
  const head = await file.slice(0, FINGERPRINT_SAMPLE_BYTES).arrayBuffer();
  const tail = await file
    .slice(Math.max(0, file.size - FINGERPRINT_SAMPLE_BYTES))
    .arrayBuffer();
  const metadata = new TextEncoder().encode(
    JSON.stringify([file.name, file.size, file.lastModified, file.type]),
  );
  const bytes = new Uint8Array(
    metadata.length + head.byteLength + tail.byteLength,
  );
  bytes.set(metadata);
  bytes.set(new Uint8Array(head), metadata.length);
  bytes.set(new Uint8Array(tail), metadata.length + head.byteLength);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
}
